<!--Navigation Bar-->
<app-navbar>
    <h2>Pachete</h2>
</app-navbar>


<app-company-credits></app-company-credits>
<!--Footer-->
<app-footer></app-footer>
